import { Icon, IconName } from 'component-library/components/icons/Icon';
import { RetirableLogoWithText } from 'component-library/components/icons/RetirableLogoWithText';
import { Flex } from 'component-library/components/layout/Flex';
import { LinkWrapper } from 'component-library/components/links/LinkWrapper';
import { Body } from 'component-library/components/typography/Body';
import { colors } from 'component-library/styles/colors';
import { device } from 'component-library/styles/device';
import React, { FC } from 'react';
import styled from 'styled-components';

import { FooterProps } from '.';

const SocialsWrapper = styled(Flex)`
  flex-direction: column;

  ${`@media ${device.xl}`} {
    flex-direction: row;
  }
`;

const LogoAndSocials = styled(Flex)`
  ${`@media ${device.xl}`} {
    margin-right: 5%;
  }
`;

export const Socials = () => (
  <SocialsWrapper>
    <LogoAndSocials column>
      <RetirableLogoWithText />
      <Flex marginBottom={64} marginTop={32} column>
        <Body variant={4} medium marginBottom={32}>
          To empower a confident, worry-free retirement for everyone.
        </Body>
        <Flex>
          <LinkWrapper to="https://www.facebook.com/Retirable/">
            <Icon
              marginRight={16}
              name={IconName.Facebook}
              color={colors.white}
            />
          </LinkWrapper>
          <LinkWrapper to="https://www.linkedin.com/company/retirable">
            <Icon
              marginRight={16}
              name={IconName.LinkedIn}
              color={colors.white}
            />
          </LinkWrapper>
          <LinkWrapper to="https://twitter.com/retirable">
            <Icon
              marginRight={16}
              name={IconName.Twitter}
              color={colors.white}
            />
          </LinkWrapper>
        </Flex>
      </Flex>
    </LogoAndSocials>
  </SocialsWrapper>
);
